import React, { ReactElement, Component, useState, useEffect, useContext, Fragment, useMemo, useCallback } from "react";
import "./users-profile-delete.less";
import { Row, Col, Button, Input, Tag, Table, Spin, Modal, Tooltip } from "antd";
import { injectIntl, FormattedMessage } from "react-intl";
import { SearchOutlined, DeleteFilled, LoadingOutlined, CheckOutlined, DownOutlined, RightOutlined, ClearOutlined } from "@ant-design/icons";
import { UserInfoContext } from "../../contexts/user-info";
import { useDeepCompareMemo, useDeepCompareEffect } from 'use-deep-compare';
import { worker_fetch } from "../../worker/worker-fetch";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { user, UserContext } from "../../contexts/user-management";
import { parse_to_kebab, formatDate } from "../user-management/user-util";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface delete_type {
    redio: string[];
    cluster: string;
    key: string;
    namespace?: string;
    roleName: string;
    username: string
    workspaceId?: string;
    workspaceName?: string;
    status?: string;
};

interface user_list_type {
    userName: string;
    userId: string;
};

interface datasource_type {
    redio?: string[];
    username: string;
    userId: string;
    data: [];
};

export const UsersProfileDelete = injectIntl((props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const user_info = useContext(UserInfoContext)[0],
        datacenter_name = useContext(DatacenternameContext)[0],
        [userlist, set_userlist]: [user[], React.Dispatch<React.SetStateAction<any>>] = useContext(UserContext),

        [show_userlist, set_show_userlist]: [user[], React.Dispatch<React.SetStateAction<any>>] = useState([]),
        [is_spin, set_is_spin]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [user_page_number, set_user_page_number]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(1),
        [page_number, set_page_number]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(1),
        // [total_count, set_total_count]: [number, React.Dispatch<React.SetStateAction<number>>] = useState(0),
        [search_value, set_search_value]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(''),
        [user_keys, set_user_keys]: [user_list_type | undefined, React.Dispatch<React.SetStateAction<user_list_type | undefined>>] = useState(),
        [userId_keys, set_userId_keys]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState(['']),
        [resourceInfo_datasource, set_resourceInfo_datasource]: [datasource_type[], React.Dispatch<React.SetStateAction<any>>] = useState([]),
        [deleteDada, set_deleteData]: [delete_type[], React.Dispatch<React.SetStateAction<any>>] = useState([]),
        [deleteDada_res, set_deleteData_res]: [delete_type[], React.Dispatch<React.SetStateAction<any>>] = useState([]),
        [refresh, set_refresh]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [refresh_userlist, set_refresh_userlist]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [delete_modal_visible, set_delete_modal_visible] = useState(false),
        [deleteRes_modal_visible, set_deleteRes_modal_visible] = useState(false),
        [is_user_spin, set_is_user_spin]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
        [delete_disable, set_delete_disable]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true),
        { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
        { history } = useMemo(() => props, [props]);

    const userlist_columns = [
        {
            title: formatMessage({ id: "name" }),
            dataIndex: "username",
            render: (username: any) => (
                <div className="font-w-7">
                    <span>{username}</span>
                    {(resourceInfo_datasource.find((each: datasource_type) => each.username === username))?.redio ? <CheckOutlined className="check_icon" /> : ''}
                </div>
            )
        },
        {
            title: formatMessage({ id: "status" }),
            dataIndex: "status",
            render: (status: any) => (
                status ? <Tag className="font-w-7" color={status.toLowerCase() === 'active' ? '#2bc41ab5' : 'lightgray'}><span className="tag_status font-w-7">{status}</span></Tag> : status
            )
        },
        {
            title: formatMessage({ id: 'last_login' }),
            dataIndex: 'lastSignedInTime',
            sorter: (a: any, b: any) => {
                let a_time = new Date(a.lastSignedInTime).getTime();
                let b_time = new Date(b.lastSignedInTime).getTime();
                return a_time - b_time;
            },
            render: (login: any) => <span className="font-w-7">{formatDate(login) || formatMessage({ id: 'not_login' })}</span>,
        },
    ];

    const users_columns = [
        {
            title: formatMessage({ id: "name" }),
            dataIndex: "username",
        },
        {
            title: formatMessage({ id: "cluster" }),
            dataIndex: "cluster",
            render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
        },
        {
            title: formatMessage({ id: "workspace" }),
            dataIndex: "workspaceName",
            render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
        },
        {
            title: formatMessage({ id: "namespace" }),
            dataIndex: "namespace",
            render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
        },
        {
            title: formatMessage({ id: "role" }),
            dataIndex: "roleName",
        },
    ];

    const users_columns_res = [
        {
            title: formatMessage({ id: "name" }),
            dataIndex: "username",
        },
        {
            title: formatMessage({ id: "cluster" }),
            dataIndex: "cluster",
            render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
        },
        {
            title: formatMessage({ id: "workspace" }),
            dataIndex: "workspaceName",
            render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
        },
        {
            title: formatMessage({ id: "namespace" }),
            dataIndex: "namespace",
            render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
        },
        {
            title: formatMessage({ id: "role" }),
            dataIndex: "roleName",
        },
        {
            title: formatMessage({ id: "status" }),
            dataIndex: "status",
            render: (status: any) => (
                status ? <Tag color={status.toLowerCase() === 'success' ? '#2bc41ab5' : 'lightgray'}><span className="tag_status">{status}</span></Tag> : status
            )
        },
    ];

    useEffect(() => {
        if (datacenter_name && user_info.userName && (userlist.length <= 0 || refresh_userlist || !refresh_userlist)) {
            // if (datacenter_name && user_info.userName && userlist.length <= 0) {
            (async () => {
                const
                    get_total: number = (await worker_fetch({
                        url: `/v1/users/info?pageNumber=1&pageSize=1&datacenter=${datacenter_name}`,
                        props: { formatMessage, history },
                        datacenter_name
                    }) as any).data?.totalCount;
                const users: any = { items: [], totalCount: 0 },
                    userlist = [];
                get_total === 0 && set_is_spin(false);
                if (Math.ceil(get_total / 100) > 0) {
                    set_is_spin(true);
                    for (let i = 1; i <= Math.ceil(get_total / 100); i++) {
                        const list = (await worker_fetch({
                            url: `/v1/users/info?pageNumber=${i}&pageSize=100&datacenter=${datacenter_name}`,
                            props: { formatMessage, history },
                            datacenter_name
                        }) as any).data?.items;
                        list && userlist.push(...list);
                    }
                    users.items = userlist;
                    users.totalCount = userlist.length;
                }
                if (users) {
                    set_is_spin(false);
                    if (Array.isArray(users.items)) {
                        set_userlist(users.items
                            .filter((each: any) => each.status.toLocaleLowerCase() !== 'delete')
                            .map((item: any, index: number) => ({
                                key: index.toString() + item.userId,
                                id: item.userId,
                                username: item.username,
                                role: item.role,
                                status: item.status,
                                lastSignedInTime: item.lastSignedInTime,
                            })));
                    }
                }
            })();
        }
        // eslint-disable-next-line
    }, [datacenter_name, set_userlist, set_is_spin, user_info.userName, history, refresh_userlist]);

    useDeepCompareEffect((): void => {
        if (Array.isArray(userlist) && userlist.length > 0) {
            const show_userlist_new: user[] = userlist.filter((item: any) => ((item?.username || "").toLocaleLowerCase()).includes(search_value.toLocaleLowerCase().trim()));
            // set_total_count(show_userlist_new.length);

            // const datas: any = [...show_userlist_new];
            // const list: user[] = datas.slice((page_number - 1) * 10, page_number * 10);
            set_show_userlist(show_userlist_new);
        }
        // eslint-disable-next-line
    }, [userlist, search_value]);

    useDeepCompareEffect((): void => {
        if (user_keys && user_keys.userId && datacenter_name) {
            if (!(resourceInfo_datasource.find((each: any) => each.userId === user_keys.userId))) {
                (async () => {
                    set_is_user_spin(true)
                    const resource_info_pre0: [] = (await worker_fetch({
                        url: `/v1/datacenter/${datacenter_name}/resourceinfo?userid=${user_keys.userId}`,
                        props: { formatMessage, history },
                        datacenter_name
                    }) as any).data?.roles;

                    // const resource_info_pre: any = (resource_info_pre0 && resource_info_pre0.length > 0) ? resource_info_pre0.filter((itemInfo: any) => itemInfo.watchOnly !== true) : [];
                    const resource_info_pre: any = resource_info_pre0;
                    // 一个集群下所有workspace
                    const resource_info_wk: any = [];
                    if (resource_info_pre && resource_info_pre.length > 0) {
                        for (let item of resource_info_pre) {
                            let item_new: any = item;
                            const resource_info_wk_each: [] = (await worker_fetch({
                                url: `/v1/datacenter/${datacenter_name}/cluster/${item_new.cluster}/workspacenames`,
                                props: { formatMessage, history },
                                datacenter_name
                            }) as any).data?.items;
                            resource_info_wk.push({
                                cluster: item_new.cluster,
                                workspacenames: resource_info_wk_each
                            })
                        }
                    }

                    const resource_info: any = [];
                    resource_info_pre && resource_info_pre.length > 0 && resource_info_pre.map((item: any, index: number) => {
                        // if (!(item.watchOnly)) {
                        //     resource_info.push({
                        //         key: user_keys.userId + index,
                        //         username: user_keys.userName,
                        //         userId: user_keys.userId,
                        //         namespace: item.namespace || '*',
                        //         workspaceId: item.workspace,
                        //         workspaceName: (((resource_info_wk.filter((each: any) => each.cluster === item.cluster))[0].workspacenames)?.filter((wk_item: any) => wk_item.id === item.workspace))[0]?.name || '*',
                        //         cluster: item.cluster,
                        //         roleName: item.roleName,
                        //     })

                        // }
                        resource_info.push({
                            key: user_keys.userId + index,
                            username: user_keys.userName,
                            userId: user_keys.userId,
                            namespace: item.namespace || '*',
                            workspaceId: item.workspace,
                            workspaceName: (((resource_info_wk.filter((each: any) => each.cluster === item.cluster))[0]?.workspacenames || [])?.filter((wk_item: any) => wk_item.id === item.workspace))[0]?.name || '*',
                            cluster: item.cluster,
                            roleName: item.roleName,
                            watchOnly: item.watchOnly,
                        })
                        return resource_info;
                    })
                    let resourceInfo_datasource_new = resourceInfo_datasource;
                    // let resourceInfo_datasource_new_find = resourceInfo_datasource_new.find((each: any) => each.userId === user_keys.userId);
                    // if (resourceInfo_datasource_new_find) {
                    //     resourceInfo_datasource_new_find = {
                    //         // redio: resourceInfo_datasource[user_keys_parse.index]?.redio || undefined,
                    //         username: user_keys.userName,
                    //         userId: user_keys.userId,
                    //         redio: undefined,
                    //         data: resource_info,
                    //     };
                    // } else {
                    resourceInfo_datasource_new.push({
                        username: user_keys.userName,
                        userId: user_keys.userId,
                        redio: undefined,
                        data: resource_info,
                    })
                    // }
                    set_resourceInfo_datasource(resourceInfo_datasource_new)
                    set_is_user_spin(false)
                })()
            } else {
                let resourceInfo_datasource_new = resourceInfo_datasource;
                let resourceInfo_datasource_new_find = resourceInfo_datasource_new.find((each: any) => each.userId === user_keys.userId);
                if (resourceInfo_datasource_new_find) {
                    resourceInfo_datasource_new_find = {
                        // redio: resourceInfo_datasource[user_keys_parse.index]?.redio || undefined,
                        username: user_keys.userName,
                        userId: user_keys.userId,
                        redio: undefined,
                        data: resourceInfo_datasource_new_find.data,
                    };
                }
                set_resourceInfo_datasource(resourceInfo_datasource_new)
            }

        }
        // eslint-disable-next-line
    }, [user_keys, datacenter_name, resourceInfo_datasource, refresh]);

    useEffect(() => {
        if (resourceInfo_datasource && resourceInfo_datasource.length > 0) {
            const delete_data_new: delete_type[] = [];
            resourceInfo_datasource.map((item: any) => {
                if (item.redio) {
                    const find_delete: any = item.data.find((each: any) => each.key === item.redio[0])
                    if (find_delete) {
                        delete_data_new.push({
                            redio: item.redio,
                            cluster: find_delete.cluster,
                            key: find_delete.key,
                            namespace: find_delete.namespace,
                            roleName: find_delete.roleName,
                            username: find_delete.username,
                            workspaceId: find_delete.workspaceId,
                            workspaceName: find_delete.workspaceName,
                        })
                    }

                }
                return delete_data_new;
            })
            delete_data_new.length > 0 ? set_delete_disable(false) : set_delete_disable(true)
            set_deleteData(delete_data_new);
        }
    }, [resourceInfo_datasource, resourceInfo_datasource.length, refresh]);

    const handle_delete = useCallback(() => {
        (async () => {
            if (datacenter_name && deleteDada && deleteDada.length > 0) {
                set_delete_modal_visible(false);
                set_deleteRes_modal_visible(true);
                const users_new: any = [];
                deleteDada.map((item: delete_type) => {
                    users_new.push({
                        user: item.username,
                        Roles: [
                            {
                                datacenter: datacenter_name,
                                cluster: item.cluster,
                                role: parse_to_kebab(item.roleName),
                                workspace: item.workspaceId || '',
                                namespace: item.namespace === "*" ? "" : item.namespace,
                            }
                        ]
                    });
                    return users_new
                });

                const request_list = {
                    userroles: users_new,
                };
                const res: any = await worker_fetch({ url: `/v1/datacenter/${datacenter_name}/muserrolebinding`, method: 3, body: request_list, props: { formatMessage, history }, datacenter_name });

                if (res && res.data && res.data.length > 0) {
                    const deleteData_res_new: delete_type[] = [];
                    res.data.map((item: any) => {
                        deleteData_res_new.push({
                            status: item.status,
                            redio: (deleteDada.find((each: delete_type) => each.username === item.user))?.redio || [],
                            cluster: (deleteDada.find((each: delete_type) => each.username === item.user))?.cluster || '',
                            key: (deleteDada.find((each: delete_type) => each.username === item.user))?.key || '[]',
                            namespace: (deleteDada.find((each: delete_type) => each.username === item.user))?.namespace || '[]',
                            roleName: (deleteDada.find((each: delete_type) => each.username === item.user))?.roleName || '[]',
                            username: (deleteDada.find((each: delete_type) => each.username === item.user))?.username || '[]',
                            workspaceId: (deleteDada.find((each: delete_type) => each.username === item.user))?.workspaceId || '[]',
                            workspaceName: (deleteDada.find((each: delete_type) => each.username === item.user))?.workspaceName || '[]',
                        })
                        return deleteData_res_new;
                    })
                    set_deleteData_res(deleteData_res_new);
                }
            }
        })()
        // eslint-disable-next-line
    }, [deleteDada, datacenter_name]);

    useEffect((): void => {
        set_search_value("");
        set_resourceInfo_datasource([]);
        set_user_keys(undefined);
        set_page_number(1);
        set_userId_keys([""]);
    }, [refresh_userlist]);

    const expended_table = (record: user) => {
        return (
            <Row className="management-table w-100 no_pointer mt-20">
                {
                    is_user_spin ? <div className="text-center w-100"><Spin indicator={antIcon} /></div> :
                        <div className="w-100">
                            <div className="clear_icon" onClick={() => {
                                let redio_no: any = [];
                                redio_no = resourceInfo_datasource;
                                let redio_no_find = redio_no.find((each: datasource_type) => each.userId === user_keys?.userId);
                                if (redio_no_find) {
                                    redio_no_find.redio = undefined;
                                    set_resourceInfo_datasource(redio_no);
                                    set_refresh(!refresh);
                                }
                                set_resourceInfo_datasource(redio_no);
                                set_refresh(!refresh);
                            }}><Tooltip title={<FormattedMessage id="clear" />}><ClearOutlined /></Tooltip></div>
                            <div className="position-relative">
                                <Table className="second-table-header" columns={users_columns} dataSource={resourceInfo_datasource.find((each: datasource_type) => each.userId === record.id) ? (resourceInfo_datasource.find((each: datasource_type) => each.userId === record.id))?.data : []} rowClassName={() => 'font-w-7'}
                                    onChange={(pagination: any) => { set_user_page_number(pagination.current) }}
                                    pagination={{ pageSize: 5, current: user_page_number, showSizeChanger: false, hideOnSinglePage: true, }} showSorterTooltip={false} rowSelection={{
                                        type: 'radio',
                                        selectedRowKeys: resourceInfo_datasource.find((each: datasource_type) => each.userId === user_keys?.userId)?.redio,
                                        getCheckboxProps: (record: any) => ({
                                            disabled: record.watchOnly
                                        }),
                                        onSelect: (record: any) => {
                                            let list: any = [];
                                            list = resourceInfo_datasource;
                                            let list_find = list.find((each: datasource_type) => each.userId === user_keys?.userId);
                                            if (list_find) {
                                                list_find.redio = [record.key];
                                                set_resourceInfo_datasource(list);
                                                set_refresh(!refresh);
                                            }
                                            set_resourceInfo_datasource(list);
                                            set_refresh(!refresh);
                                        },
                                    }}
                                />
                            </div>
                        </div>
                }
            </Row>
        )
    }

    return (
        <Fragment>
            <div className="mx-20 mb-10 mt-20">
                <span className="card_title management-label-line font-size-16"><FormattedMessage id="batch_delete" /></span>
            </div>
            <div className="w-100 px-20">
                <div className="management-select-area w-100">
                    <Row gutter={10}>
                        <Col sm={22} xxl={23}>
                            <Input
                                className={"mt-24 box_rounded input_no_border search_input_height"}
                                size="large"
                                style={{ height: '32px' }}
                                allowClear={true}
                                value={search_value}
                                placeholder={formatMessage({
                                    id: "please_input_keywords",
                                })}
                                prefix={<SearchOutlined />}
                                onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
                                    if (event.keyCode === 13) event.preventDefault();
                                }}
                                onChange={(e) => {
                                    set_search_value(e.target.value);
                                    set_page_number(1);
                                }}
                            />

                        </Col>
                        <Col sm={2} xxl={1} className="text-right mt-10">
                            <Button className="plain_button" type="primary" disabled={delete_disable} onClick={() => { set_delete_modal_visible(true) }}>
                                <DeleteFilled />
                            </Button></Col>
                    </Row>

                </div>
            </div>

            <Spin spinning={is_spin} tip="Loading..." size="large">
                <div className="management-table w-100 no_pointer mt-20 no_pointer px-20 profile-card_delete">
                    <Table
                        size="small"
                        columns={userlist_columns}
                        rowKey={(user: any) => user.id}
                        expandable={{
                            expandedRowKeys: userId_keys,
                            expandedRowRender: (record: user) => expended_table(record),
                            expandIcon: ({ expanded, onExpand, record }) => expanded ?
                                <DownOutlined onClick={e => onExpand(record, e)} /> :
                                <RightOutlined onClick={e => onExpand(record, e)} />,
                            onExpand: (expanded, record) => {
                                if (expanded) {
                                    set_userId_keys([record.id])
                                    set_user_keys({
                                        userName: record.username,
                                        userId: record.id,
                                    })
                                } else {
                                    set_userId_keys([""])
                                }
                            }
                        }}
                        dataSource={show_userlist}
                        onChange={(pagination: any) => { set_page_number(pagination.current) }}
                        pagination={{ pageSize: 10, current: page_number, showSizeChanger: false }} showSorterTooltip={false}
                    />
                </div>
            </Spin>

            <Modal width="960px" title={formatMessage({ id: "confirm" })} visible={delete_modal_visible} onOk={() => handle_delete()} onCancel={() => { set_delete_modal_visible(false); }}>
                <p><FormattedMessage id="are_yuo_sure_to_delete_follow_users_permission" /></p>
                <Table size="small" className="ant-col-sm-24" columns={users_columns} dataSource={deleteDada} pagination={false} />
            </Modal>
            <Modal width="960px" title={formatMessage({ id: "confirm" })} visible={deleteRes_modal_visible} footer={null} onCancel={() => { set_deleteRes_modal_visible(false); set_refresh_userlist(!refresh_userlist) }}>
                <p><FormattedMessage id="delete_results_are_follows" /></p>
                <Table size="small" className="ant-col-sm-24" columns={users_columns_res} dataSource={deleteDada_res} pagination={false} />
            </Modal>
        </Fragment>
    );
});
